/**
 *  Date    : 2019/11/7
 *  Author  : Weilin
 *  Declare : user
 */
import Immutable from 'seamless-immutable';

import bookApi from '@/api/bookapi';

const namespace = 'book';

export default {
  namespace,
  state: Immutable({
    newsSourceList: [],
    bookCacheData: {}
  }),
  reducers: {
    update: (state, { data, field }) => state.merge({ [field]: data })
  },
  actions: {
    getNewsSourceList() {
      return {
        type: namespace + '/update/getNewsSourceList',
        field: 'newsSourceList',
        promise: bookApi.getNewsSourceList()
      };
    },
    setBookCacheData(data) {
      return {
        type: namespace + '/update/bookCacheData',
        field: 'bookCacheData',
        data: data
      };
    }
  }
};
